import { defineComponent as g, ref as A, inject as E, computed as o, toRaw as N, openBlock as m, createElementBlock as c, normalizeClass as n, unref as l, createElementVNode as p, withDirectives as B, vModelCheckbox as D, renderSlot as $, Fragment as w, createTextVNode as M, toDisplayString as S, createCommentVNode as h } from "vue";
import { checkboxProps as U, checkboxEmits as j } from "./checkbox.js";
import "./checkbox.css";
import "../checkbox-group/index.js";
import { useNamespace as x } from "../../hooks/use-namespace.js";
import "../../hooks/use-z-index.js";
import { isUndefined as z, isArray as F, isBoolean as K } from "../../utils/types.js";
import { checkboxGroupContextKey as P } from "../checkbox-group/checkbox-group.js";
const R = ["name", "value", "tabindex", "disabled"], T = g({
  name: "ApCheckbox"
}), X = /* @__PURE__ */ g({
  ...T,
  props: U,
  emits: j,
  setup(k, { emit: C }) {
    const r = k, f = C, b = A(!1), a = E(P, void 0), v = o(() => z(a) === !1), t = x("checkbox"), i = o({
      get() {
        var e;
        return v.value ? (e = a == null ? void 0 : a.modelValue) == null ? void 0 : e.value : r.modelValue ?? b.value;
      },
      set(e) {
        var s;
        v.value && F(e) ? (s = a == null ? void 0 : a.changeEvent) == null || s.call(a, e) : (f("update:modelValue", e), b.value = e);
      }
    }), d = o(() => r.disabled), y = o(() => {
      const e = i.value;
      return K(e) ? e : Array.isArray(e) ? e.map(N).includes(r.label) : !!e;
    }), V = (e) => {
      const u = e.target.checked === !0;
      f("change", u);
    };
    return (e, s) => (m(), c("label", {
      class: n([
        l(t).b(),
        l(t).is("checked", y.value),
        l(t).is("disabled", d.value)
      ])
    }, [
      p("span", {
        class: n([l(t).e("input"), l(t).is("disabled", d.value)])
      }, [
        B(p("input", {
          type: "checkbox",
          class: n(l(t).e("inner")),
          name: e.name,
          value: e.label,
          "onUpdate:modelValue": s[0] || (s[0] = (u) => i.value = u),
          tabindex: e.tabindex,
          disabled: d.value,
          onChange: V
        }, null, 42, R), [
          [D, i.value]
        ]),
        p("span", {
          class: n(l(t).e("icon"))
        }, null, 2)
      ], 2),
      e.$slots.default || e.label ? (m(), c("span", {
        key: 0,
        class: n(l(t).e("label"))
      }, [
        $(e.$slots, "default"),
        e.$slots.default ? h("", !0) : (m(), c(w, { key: 0 }, [
          M(S(e.label), 1)
        ], 64))
      ], 2)) : h("", !0)
    ], 2));
  }
});
export {
  X as default
};
